'use client'

import {
	BreadcrumbItemProps,
	Breadcrumbs,
} from '@hashicorp/react-mds/src/components/breadcrumbs'

interface BreadcrumbsProps {
	items: BreadcrumbItemProps[]
}

const CareersBreadcrumbs = ({ items }: BreadcrumbsProps) => {
	return (
		<Breadcrumbs.Root>
			{items.map((item, idx) => (
				<Breadcrumbs.Item
					{...item}
					current={idx === items.length - 1}
					key={item.text}
				/>
			))}
		</Breadcrumbs.Root>
	)
}

export { CareersBreadcrumbs }
